import React, { useState, useEffect } from 'react'
import Card from '@mui/material/Card'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useLocation, useParams } from 'react-router-dom'

import { Snackbar } from '@mui/material'
const GoHighLevel = () => {
  const { locationId, companyId, app_id } = useParams()
  const [buttonText, setButtonText] = useState('Connect')
  const { search } = useLocation()
  const type = new URLSearchParams(search).get('type')

  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  })
  const { vertical, horizontal, open } = state

  const handleClose = () => {
    setState({ ...state, open: false })
  }

  const auth_url = `https://acuityscheduling.com/oauth2/authorize?response_type=code&scope=api-v1&client_id=carem8ox53PWnPxg&redirect_uri=http://localhost:3000/integrations/acquity/&state=${locationId},${companyId},${app_id},${type}`

  const handleSubmit = (event) => {
    event.preventDefault()
    window.open(auth_url, '_blank')
    setButtonText('Connected')
    setState({ ...state, open: true })
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundImage:
          'url("https://cdn.pixabay.com/photo/2016/09/05/15/07/concrete-1646788_1280.jpg")',
        backgroundSize: 'cover',
      }}
    >
      <Card
        sx={{
          width: '42%',
          textAlign: 'center',
          padding: '2rem',
          borderRadius: '29px',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
        }}
      >
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          p={2}
          mb={1}
        >
          <MDTypography variant="h4" gutterBottom style={{ color: 'white' }}>
            Connect with Acquity
          </MDTypography>
        </MDBox>

        <MDBox component="form" onSubmit={handleSubmit} sx={{ mt: 15 }}>
          <MDButton
            type="submit"
            variant="contained"
            color="info"
            fullWidth
            sx={{ mt: 2 }}
            style={{ fontSize: '0.9rem', textTransform: 'capitalize' }}
          >
            {buttonText}
          </MDButton>

          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            onClose={handleClose}
            message="Connected Successfully"
            key={vertical + horizontal}
          />
        </MDBox>
      </Card>
    </div>
  )
}

export default GoHighLevel
